/**
 *
 * Create Group
 *
 */
 Vue.component("create-group", {

    data: function() {
        return {
            isProcessing: false,
            name: null,
            teamIds: []
        };
    },

    template: `
	<div class="d-flex justify-content-center w-75 mx-auto p-3">
		<form id="create-new-group" style="width:100%;">

			<div class="input-and-submit-wrapper form-group">
				<div class="form-icon">
					<i class="fas fa-group"></i>
				</div>
				<input
					type="text" class="has-icon form-control" name="group-name" id="group-name"
					v-model="name"
					placeholder="Name of the group"
				>
			</div>

			<div>

			</div>

			<div class="btn-toolbar" role="group" aria-label="">
				<button type="submit" class="btn btn-primary btn-submit"
						@click.prevent="createGroup"
						:disabled="isProcessing">

					<span v-if="isProcessing">
						<i class="fa fa-btn fa-spinner fa-spin"></i> {{__('CREATING..')}}
					</span>

					<span v-else>
						{{__('CREATE')}}
					</span>

				</button>
			</div>
		</form>
	</div>
	`,

    mounted() {},

    methods: {
        createGroup(event) {
            var instance = this;
            instance.isProcessing = true;

            axios
                .post("/api/groups", {
                    name: instance.name,
                    team_ids: instance.teamIds
                })
                .then(response => {
                    var responseData = response.data;
                    if ("id" in responseData && responseData.id) {
                        instance.isProcessing = true;
                        swal(
                            "Congrats!",
                            "Group Created Successfully",
                            "success"
                        );
                        instance.name = null;
                    } else {
                        instance.isProcessing = false;
                        this.handleAxiosError(
                            "Problem creating Group",
                            response
                        );
                    }
                })
                .catch(error => {
                    instance.isProcessing = false;
                    this.handleAxiosError("Problem creating Group", error);
                });
        }
    }
});

/**
 *
 * Manage Group (add/remove Teams and Users)
 *
 */

import { mixin as clickaway } from 'vue-clickaway';
Vue.component("manage-group", {

    mixins: [clickaway],

    data: function() {
        return {
            isProcessing: false,
            groups: [],
            groupId: null,
            groupData: {},
            groupTeams: [],
            groupUsers: [],
            teamsToAdd: [],
            usersToAdd: [],
            teamIdToAdd: null,
            userIdToAdd: null,
            searchTeamsFilter: '',
            teamsShown: false,
            searchUsersFilter: '',
            usersShown: false,
            hoveredElementId: null,
        };
    },

    template: `
	<div>
		<div class="row mx-0 align-items-center justify-content-center">
			<div class="col-lg-12">
				<label v-if="!groupId">Please select a Group</label>
				<label v-else>Group</label>&nbsp;
				<select v-model="groupId" class="manage-groups-group-select-list">
					<option v-for="aGroup in groups" v-bind:value="aGroup.id">
						{{ aGroup.id + ' - ' + aGroup.name }}
					</option>
				</select>
				&nbsp;&nbsp;
				<button v-if="!isProcessing" @click.prevent="fillInGroups" :disabled="isProcessing" class="btn btn-primary" title="Refresh list of Groups">
					<i class="fa fa-btn fa-refresh"></i>
				</button>
			</div>
		</div>

		<br>
		<br>

		<div class="row mx-0" v-if="groupId">
			<div class="col-lg-6">
				<h5>Hotels in Group</h5>
				<br>
				<div v-on-clickaway="exitTeams">
					<label>Select a hotel to add it to the group</label>
                    <div class="input-and-submit-wrapper form-group">
                        <div class="form-icon">
                            <i class="fas fa-search"></i>
                        </div>
                        <input
                            type="text"
                            :disabled="isProcessing"
                            class="has-icon form-control"
                            v-model="searchTeamsFilter"
                            placeholder="Type Property Name"
                            @click.prevent="showFilteredTeams"
                        />
                    </div>
                    <!-- Dropdown Menu -->
                    <div class="dropdown-content manage-groups-scrollable-filter-results vertical-scroll" v-show="teamsShown">
                        <div v-for="team in filteredTeams" :key="team.id" v-bind:value="team.id"
                            class="dropdown-item"
                            @click.prevent="selectTeam(team.id)">
                            {{ team.id + ' - ' + team.name }}
                        </div>
                    </div>
				</div>
				<br>
				<div v-if="!isProcessing">
					<ul class="manage-groups-group-team-list">
						<li v-for="aGroupTeam in groupTeams" :key="aGroupTeam.id"  class="manage-groups-group-team-list-item" 
                            @mouseover="hoveredElement('team-' + aGroupTeam.id)" @mouseleave="unhoveredElement"
                        >
							<group-team :groupteam="aGroupTeam" @removedteam="refreshContents" 
                                :hovered="hoveredElementId == 'team-' + aGroupTeam.id"
                            ></group-team>
						</li>
					</ul>
				</div>
				<div v-else>
					Working...
					<i class='fa fa-spinner fa-spin fa-5x'></i>
				</div>
			</div>

			<div class="col-lg-6">
				<h5>Users in Group</h5>
				<br>
				<div v-on-clickaway="exitUsers">
					<label>Select a user to add them to the group</label>
                    <div class="input-and-submit-wrapper form-group">
                        <div class="form-icon">
                            <i class="fas fa-search"></i>
                        </div>
                        <input
                            type="text"
                            :disabled="isProcessing"
                            class="has-icon form-control"
                            v-model="searchUsersFilter"
                            placeholder="Type User's Name"
                            @click.prevent="showFilteredUsers"
                        />
                    </div>
                    <!-- Dropdown Menu -->
                    <div class="dropdown-content manage-groups-scrollable-filter-results vertical-scroll" v-show="usersShown">
                        <div v-for="user in filteredUsers" :key="user.id" v-bind:value="user.id"
                            class="dropdown-item"
                            @click.prevent="selectUser(user.id)">
                            {{ user.id + ' - ' + user.name }}
                        </div>
                    </div>
				</div>
				<br>
				<div v-if="!isProcessing">
					<ul class="manage-groups-group-user-list">
						<li v-for="aGroupUser in groupUsers" :key="aGroupUser.id"  class="manage-groups-group-user-list-item"
                            @mouseover="hoveredElement('user-' + aGroupUser.id)" @mouseleave="unhoveredElement"
                        >
							<group-user :groupuser="aGroupUser" @removeduser="refreshContents" 
                                :hovered="hoveredElementId == 'user-' + aGroupUser.id"
                            ></group-user>
						</li>
					</ul>
				</div>
				<div v-else>
					Working...
					<i class='fa fa-spinner fa-spin fa-5x'></i>
				</div>
			</div>
		</div>
	</div>
	`,

    mounted() {
        this.fillInGroups();
    },

    watch: {
        groupId: function(val) {
            console.log("Watch groupId (selected): " + val);
            if (val) {
                this.loadGroupData(val);
            } else {
                this.resetGroupId();
            }
        }
    },

    computed: {

        activeTeams() {
            return this.groupTeams.map(team => {
                return team.team_id;
            });
        },

        activeUsers() {
            return this.groupUsers.map(user => {
                return user.user_id;
            });
        },

        filteredTeams() {
            return this.teamsToAdd.filter(team => {
                if (this.activeTeams.indexOf(team.id) > 0) return false;

                return team.name.toLowerCase().includes(this.searchTeamsFilter.toLowerCase());
            })
        },

        filteredUsers() {
            return this.usersToAdd.filter(user => {
                if (this.activeTeams.indexOf(user.id) > 0) return false;

                return user.name.toLowerCase().includes(this.searchUsersFilter.toLowerCase());
            })
        },
    },

    methods: {
        // new method
        selectTeam(teamId) {
            console.log(teamId);
            this.selectedTeam = teamId,
            this.addTeam(teamId);
            this.teamsShown = false;
        },

        selectUser(userId) {
            this.selectedUser = userId,
            this.addUser(userId);
            this.usersShown = false;
        },

        showFilteredTeams() {
            if (!this.disabled){
                this.searchTeamsFilter = '';
                this.teamsShown = true;
            }
        },

        showFilteredUsers() {
            if (!this.disabled){
                this.searchUsersFilter = '';
                this.usersShown = true;
            }
        },

        exitTeams() {
            if (this.searchTeamsFilter == '') {
                this.teamsShown = false;
            }
        },

        exitUsers() {
            if (this.searchUsersFilter == '') {
                this.usersShown = false;
            }
        },

        resetGroupId() {
            this.groupId = null;
            this.groupData = {};
            this.groupTeams = [];
            this.groupUsers = [];
            this.teamsToAdd = [];
            this.usersToAdd = [];
            this.teamIdToAdd = null;
            this.userIdToAdd = null;
        },

        fillInGroups() {
            var instance = this;
            instance.resetGroupId();
            instance.isProcessing = true;

            axios
                .get("/api/groups", { params: { team_ids: [], with_teams: 0 } })
                .then(response => {
                    // var responseData = response.data
                    console.log(response.data);
                    instance.groups = response.data;
                    instance.isProcessing = false;
                })
                .catch(error => {
                    this.handleAxiosError("Problem getting Groups", error);
                });
        },

        loadGroupData(groupId) {
            var instance = this;
            instance.resetGroupId();
            instance.groupId = groupId;
            instance.isProcessing = true;

            axios
                .get("/api/groups/" + instance.groupId + "/team-and-user")
                .then(response => {
                    console.log(response.data);
                    instance.isProcessing = false;
                    if (!"group" in response.data) {
                        this.handleAxiosError(
                            "Problem loading Group data",
                            error
                        );
                    } else {
                        instance.groupData = response.data.group;
                        instance.groupTeams = response.data.teams;
                        instance.groupUsers = response.data.users;
                        instance.teamsToAdd = response.data.teams_to_add;
                        instance.usersToAdd = response.data.users_to_add;

                        // console.log(instance)
                    }
                })
                .catch(error => {
                    instance.isProcessing = false;
                    this.handleAxiosError("Problem loading Group data", error);
                });
        },

        addTeam(teamId, orderNumber) {
            // TODO: should take in 'order_number'
            console.log("Should add team " + teamId);

            var instance = this;
            instance.isProcessing = true;

            axios
                .post("/api/groups/" + instance.groupId + "/team", {
                    teamId: teamId,
                    orderNumber: orderNumber
                })
                .then(response => {
                    console.log(response.data);
                    instance.isProcessing = false;

                    this.sweetAlertTransientOk("Hotel was added to the Group");

                    this.refreshContents();
                })
                .catch(error => {
                    instance.isProcessing = false;
                    this.handleAxiosError(
                        "Problem adding Hotel to Group",
                        error
                    );
                });
        },

        addUser(userId) {
            console.log("Should add user " + userId);

            var instance = this;
            instance.isProcessing = true;

            axios
                .post("/api/groups/" + instance.groupId + "/user", {
                    userId: userId,
                    role: "group_owner"
                })
                .then(response => {
                    console.log(response.data);
                    instance.isProcessing = false;

                    this.sweetAlertTransientOk("User was added to the Group");

                    this.refreshContents();
                })
                .catch(error => {
                    instance.isProcessing = false;
                    this.handleAxiosError(
                        "Problem adding User to Group",
                        error
                    );
                });
        },

        refreshContents() {
            console.log("refreshContents of Group");
            this.loadGroupData(this.groupId);
        },

        hoveredElement(elementId) {
            this.hoveredElementId = elementId;
        },

        unhoveredElement() {
            this.hoveredElementId = null;
        }
    } // methods
});

/**
 *
 * Group Teams
 *
 */

Vue.component("group-team", {
    props: ["groupteam","hovered"],

    data: function() {
        return {
            isProcessing: false
        };
    },

    template: `
		<span>
		<button class="rounded border-0" @click.prevent="deleteGroupTeam" title="Remove from Group">
			<i :class="hovered ? 'fas fa-minus-square' : 'far fa-minus-square'"></i>
		</button>
		{{groupteam.team_id}} - {{groupteam.team_name}}
		</span>
	`,

    mounted() {},

    methods: {
        deleteGroupTeam(event) {
            var instance = this;
            instance.isProcessing = true;

            //console.log('Deleting ' + this.groupteam.id)

            axios
                .delete(
                    "/api/groups/" + instance.groupteam.group_id + "/team",
                    { params: { teamId: instance.groupteam.team_id } }
                )
                .then(response => {
                    instance.isProcessing = true;

                    this.sweetAlertTransientOk(
                        "Hotel [" +
                            instance.groupteam.team_name +
                            "] removed from Group"
                    );

                    this.$emit("removedteam");
                })
                .catch(error => {
                    instance.isProcessing = false;
                    this.handleAxiosError(
                        "Problem removing Team from Group",
                        error
                    );
                });
        }
    }
});

/**
 *
 * Group Users
 *
 */
Vue.component("group-user", {
    props: ["groupuser","hovered"],

    data: function() {
        return {
            isProcessing: false
        };
    },

    template: `
		<span>
		<button class="rounded border-0" @click.prevent="deleteGroupUser" title="Remove from Group">
			<i :class="hovered ? 'fas fa-minus-square' : 'far fa-minus-square'" ></i>
		</button>
		{{groupuser.user_name}} ({{groupuser.user_email}})
		</span>
	`,

    mounted() {},

    methods: {
        deleteGroupUser(event) {
            var instance = this;
            instance.isProcessing = true;

            //console.log('Deleting ' + this.groupuser.id)

            axios
                .delete(
                    "/api/groups/" + instance.groupuser.group_id + "/user",
                    { params: { userId: instance.groupuser.user_id } }
                )
                .then(response => {
                    instance.isProcessing = true;
                    this.sweetAlertTransientOk(
                        "User [" +
                            instance.groupuser.user_name +
                            "] removed from Group"
                    );
                    this.$emit("removeduser");
                })
                .catch(error => {
                    instance.isProcessing = false;
                    this.handleAxiosError(
                        "Problem removing User from Group",
                        error
                    );
                });
        }
    }
});

